import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import {currentUser_currentUser_notifications_nodes} from 'app/core/services/gql/currentUser';
import {BehaviorSubject} from 'rxjs';

type Notification = currentUser_currentUser_notifications_nodes;

@Component({
    selector: 'notification-banner',
    templateUrl: './notification-banner.component.html',
    styleUrls: ['./notification-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class NotificationBannerComponent implements AfterViewInit {
    @Input() node: Notification;
    @Input() backgroundType$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    @Input() isBanner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    @Output() watch: EventEmitter<{event: MouseEvent; node: Notification}> = new EventEmitter<{event: MouseEvent; node: Notification}>();
    @Output() removeItem: EventEmitter<string> = new EventEmitter<string>(null);

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef
    ) {}

    ngAfterViewInit() {
        const elem = this.elementRef.nativeElement;

        if (!elem || !this.node) {
            return;
        }

        this.isBannerNotification(elem);
        this.findBgColor(elem);

        const buttons = elem.querySelector('.button__list .button--primary');
        if (buttons && buttons.children) {
            buttons.addEventListener('click', (event: MouseEvent) => {
                this.watchNotification(event, this.node);
            });
            return;
        }

        elem.querySelector('.notification__message-banner').addEventListener('click', (event: MouseEvent) => {
            this.watchNotification(event, this.node);
        });
    }

    isBannerNotification(elementRef: HTMLElement) {
        let selector = elementRef.querySelector('.banner');
        this.isBanner.next(Boolean(selector));
    }

    findBgColor(elementRef: HTMLElement) {
        let selector = elementRef.querySelector('.background-color');

        if (!selector) {
            return;
        }

        const findColor = selector.getAttribute('class').split(' ');
        const color = findColor[findColor.length - 1].toLowerCase();
        if (color !== 'background-color') {
            this.backgroundType$.next(color);
        }
    }

    watchNotification($event: MouseEvent, node: Notification) {
        this.watch.emit({event: $event, node});
    }

    deleteNotification(id: string) {
        this.removeItem.emit(id);
    }
}
